<template>
  <transition name="zoom">
    <div class="page-content">
      <el-card v-show="showDetail"
               v-loading="loading"
               class="page-box detail-box"
               shadow="never">
        <div slot="header" class="clearfix">
          <div class="title">通知信息</div>
          <span class="close"  @click="$emit('org-inform-view','inform-list')">
            <icon-svg iconClass="close-small"></icon-svg>
          </span>
        </div>
        <div class="appl-info">
          <el-form
            :model="formData"
            :rules="rules"
            ref="form"
            label-width="100px"
            v-loading="loading"
          >
            <el-form-item label="标题名称：" prop="title">
              <el-input type="text" v-model="formData.title" placeholder="标题" class="el-input"></el-input>
            </el-form-item>
            <el-form-item label="通知类型：" prop="type">
              <el-select v-model="formData.type" placeholder="请选择通知类型" class="el-select">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="摘要：" prop="remark">
              <el-input type="textarea" v-model="formData.remark" placeholder="摘要" class="el-input"></el-input>
            </el-form-item>
            <el-form-item label="通知内容：" prop="content">
              <quill-editor v-loading="loading"
                class="content-des"
                v-model="formData.content"
                ref="basicQuillEditor"
                :options="editorOption">
              </quill-editor>
              <el-upload
                class="avatar-uploader"
                id="basic-uploader"
                :action="appApi"
                accept="image"
                :show-file-list="false"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                :before-upload="beforeUpload">
              </el-upload>
            </el-form-item>
            <div class="tc">
              <el-button
                style="width: 140px"
                v-on:click="goBack">返回
              </el-button>
              <el-button
                style="width: 140px"
                type="primary"
                @click="onSubmit">保存
              </el-button>
            </div>
          </el-form>
        </div>
      </el-card>
    </div>
  </transition>
</template>

<script>
import {orgInform} from '../../api'
import {quillEditor} from 'vue-quill-editor'
import {validImage, toolbarOptions, quillUploadSuccess} from '@/utils'
export default {
  name: 'orgInformAdd',
  components: {},
  props: {
    showDetail: {
      type: Boolean,
      default: true
    },
    param: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      appApi: process.env.VUE_APP_API + '/upload/image/single/',
      loading: false,
      editorOption: {
        placeholder: '请填写通知内容',
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              'image': function (value) {
                if (value) document.querySelector('#basic-uploader input').click()
              }
            }
          }
        }
      },
      options: [{label: '员工通知', value: '1'}, {label: '会员通知', value: '2'}],
      formData: {
        informId: '',
        createUser: this.$store.state.user.userId,
        orgCode: this.$store.state.user.orgCode,
        remark: '',
        content: '',
        title: '',
        type: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入标题名称', trigger: 'blur'},
          {max: 32, message: '长度不能超过32个字符', trigger: 'blur'}
        ],
        remark: [
          {required: true, message: '请输入摘要', trigger: 'blur'},
          {max: 100, message: '长度不能超过100个字符', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请输入通知类型', trigger: 'blue'}
        ],
        content: [
          {required: true, message: '请输入内容', trigger: 'blue'}
        ]
      }
    }
  },
  created () {
  },
  methods: {
    changeEvent (value) {
      if (value === 'add') {
        this.$refs['form'].resetFields()
        this.formData.createUser = this.$store.state.user.userId
        this.formData.orgCode = this.$store.state.user.orgCode
        this.formData.informId = ''
        this.formData.type = ''
        this.formData.content = ''
        this.formData.title = ''
      } else {
        this.getData(value)
      }
    },
    async getData (value) {
      this.loading = true
      let {data} = await orgInform.getDateil(value)
      this.formData = data
      this.loading = false
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.formData.informId) {
            this.addOrgInformInfo()
          } else {
            this.editOrgInformInfo()
          }
        } else {
          return false
        }
      })
    },
    async addOrgInformInfo () {
      let {code} = await orgInform.addOrgInfom(this.formData)
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '添加成功'
        })
        this.$emit('org-inform-view', 'inform-list', 'flush')
      } else {
        this.$message({
          type: 'error',
          message: '添加失败'
        })
      }
    },
    async editOrgInformInfo () {
      let {code} = await orgInform.editOrgInfom(this.formData)
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '修改成功'
        })
        this.$emit('org-inform-view', 'inform-list', 'flush')
      } else {
        this.$message({
          type: 'error',
          message: '修改失败'
        })
      }
    },
    // 上传图片前
    beforeUpload (file) {
      let vail = validImage(file, 500)
      this.loading = vail
      return vail
    },
    // 上传图片成功
    uploadSuccess (res) {
      this.loading = false
      let quill = this.$refs.basicQuillEditor.quill
      quillUploadSuccess(res, quill)
    },
    // 上传图片失败
    uploadError () {
      this.loading = false
      this.$message({type: 'info', message: '插入图片失败，请稍后重试'})
    },
    goBack () {
      this.$emit('org-inform-view', 'inform-list')
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-content {
    background-color: #fff;
  }
  .content-des {
    height: 300px;
    border-color: #dfe1e7;
  }
  .tc {
    text-align: center;
    margin-top: 15%;
  }
  .appl-info {
    margin-top: 40px;
    .el-select {
      width: 100%
    }
    .el-input {
      width: 100%
    }
    .el-textarea {
      width: 100%
    }
  }
  .el-card {
    top: 20px;
    right: 20px;
    left: 20px;
    z-index: 2;
    margin-bottom: 0;
    background-color: #fff;
    /deep/ .el-card__header {
      padding: 0 0 10px 0;
      .title {
        font-size: 16px;
        font-weight: 500;
      }
    }
    .close {
      margin-top: -30px;
      float: right;
      .svg-icon {
        width: 2em;
        height: 2em;
      }
    }
    /deep/ .el-card__body {
      padding: 0;
    }
    .close-win {
      text-align: center;
      margin: 20px 0 10px 0;
    }
  }
</style>
